import React from 'react';
import { Cta, CtaBanner, IBanner, ICloud } from '../../types/content';
import './Banners.scss';
import Image from '../UI/Image/Image';
import ScrollAnimation from '../ScrollAnimation/ScrollAnimation';
import CONFIG from '../../config';
import { getImage, adobeTrack, getSeeAllGamesLink } from '../../utils';
import LearnMoreButton from '../UI/Buttons/LearnMoreButton';
import PictureImage from '../UI/Image/Picture';
import { AppState } from '../../store';
import { connect } from 'react-redux';
import { IProductsState } from '../../types/store/reducer';
import { IContent } from '../../types';
import { withContent } from '../../hoc/withContext';
import DiscoverButton from '../UI/Buttons/DiscoverButton';

interface IBannerProps {
  bannerItem: IBanner;
  ctas: Cta;
  products : IProductsState;
  context? :IContent;
}

//Gets needed cloud platforms for display
const getCloudItems = (cloudItems: ICloud[], products:IProductsState) => {
  return cloudItems.map((platform: ICloud) => {
    return (
      <div  className={ "cloud-platform-item " + ((cloudItems.length === 1)  ? 'cloud-platform-single-item' : 'cloud-platform-double-item')} key={platform.image.alt}>
        <Image
          imageName={platform.image.link}
          extension={'png'}
          altText={platform.image.alt}
          className={['cloud-platform-image lazyload']}
        />
        {/*Single item text separator*/}
        {cloudItems.length === 1 && <div className={'single-cloud-separator'} />}
        <a className={'cloud-platform-games-link'} onClick={() => {
          if (CONFIG.isUPC) {
            window.location.href = getSeeAllGamesLink(products.countryCode,platform.filter);
          } else {
            let win = window.open(getSeeAllGamesLink(products.countryCode,platform.filter), '_blank');
            win.focus();
          }
        }}
        >{platform.text}</a>
      </div>
    );
  });
};

const Banner = ({ bannerItem, ctas, products, context }: IBannerProps) => {
  return (
    <section
      className={
        'banner_container ubisoft-plus_container ' +
        (bannerItem.image_direction === 'left' ? 'image_left' : 'image_right')
      }
    >
      <h2
        className="banner_title_mobile"
        dangerouslySetInnerHTML={{ __html: bannerItem.title }}
      />

      <div className={'banner_image'}>
        <ScrollAnimation
          animateIn="scaleUp"
          animatePreScroll={false}
          className="image-wrapper"
        >
          <PictureImage
            images={getImage(bannerItem.image.link)}
            extension="png"
            altText={bannerItem.image.alt}
            className={[""]}
          />
        </ScrollAnimation>
      </div>
      <div className="banner_text_container">
        <div className="banner_text">
          {/*Setup Title*/}
          <h2
            className="banner_title_PC"
            dangerouslySetInnerHTML={{ __html: bannerItem.title }}
          />
          {/*Setup description*/}
          <p className="banner_description" dangerouslySetInnerHTML={{ __html: bannerItem.description }} />
          {/*Setup cloud section*/}
          <div className="cloud_platforms_container">{bannerItem.cloud !== undefined && getCloudItems(bannerItem.cloud.filter(cloudItem => cloudItem.isAvailable === "TRUE"), products)}</div>
          {/*Setup buttons*/}
          {bannerItem.cta !== undefined && (
            <div className="banner_buttons ubisoft-plus_cta_wrapper">
              {bannerItem.cta.map((cta: CtaBanner) => {
                  if (cta.type === 'learn_more' && !CONFIG.isUPC) {
                    return (
                      <LearnMoreButton key={ctas[cta.type]} content={ctas[cta.type]}
                                              redirect={cta.redirection} handleClick={() =>
                        adobeTrack('clickevent', context.tracking.download_ubisoft_connect)
                      }/>
                    );
                  }
                  else if(cta.type === 'discover'){
                    return (<DiscoverButton key={ctas[cta.type]} content={ctas[cta.type]}
                                     handleClick={() =>
                      adobeTrack('clickevent', context.tracking.download_ubisoft_connect)
                    }/>)
                  }

                }
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  products: state.products
});

export default withContent(connect(mapStateToProps)(Banner));
